module.exports = __webpack_public_path__ + "img/mimo_2.fe97eb06.jpg";